export const REQUEST_SEARCH_CLAIM_INFO: string = 'REQUEST_SEARCH_CLAIM_INFO';
export const SET_SEARCH_CLAIM_INFO: string = 'SET_SEARCH_CLAIM_INFO';
export const REQUEST_MAKE_DECISION_CLAIM: string =
  'REQUEST_MAKE_DECISION_CLAIM';
export const RESET_STORE_OPEN_CLAIM = 'RESET_STORE_OPEN_CLAIM';
export const DECISION_METERIAL_CLAIM = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
};
